import React from 'react';

const UploadIcon: React.FC = () => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
>
    <path
        d="M15.4597 4.26724C15.4597 5.40712 15.0159 6.47873 14.2099 7.2847L6.52353 15.0623C5.89838 15.6874 5.07747 16 4.25709 16C3.43778 16 2.61847 15.688 1.99492 15.0644C0.747291 13.8162 0.747291 11.7861 1.99492 10.5385L7.54766 5.0172C8.38138 4.18883 9.70635 4.16162 10.5027 4.95693C10.8916 5.34578 11.0964 5.87065 11.0799 6.43552C11.0633 6.98813 10.8356 7.51194 10.4382 7.90932L5.16868 13.1788C4.96012 13.3874 4.62301 13.3874 4.41445 13.1788C4.20589 12.9703 4.20589 12.6332 4.41445 12.4246L9.68395 7.15509C9.88824 6.95079 10.0056 6.68409 10.0136 6.40405C10.0216 6.13628 9.92718 5.88985 9.74849 5.71116C9.36711 5.33138 8.71742 5.35858 8.3003 5.77357L2.74809 11.2938C1.91758 12.1248 1.91758 13.4786 2.74916 14.3102C3.58127 15.1418 4.93452 15.1418 5.76663 14.3102L13.453 6.5326C14.06 5.92559 14.3928 5.12228 14.3928 4.26724C14.3928 3.41219 14.06 2.60888 13.4557 2.00453C12.8508 1.39965 12.0475 1.06681 11.1924 1.06681C10.3374 1.06681 9.53406 1.39965 8.92918 2.00453L1.43378 9.44659C1.22415 9.65409 0.887043 9.65302 0.679549 9.44339C0.472054 9.2343 0.473121 8.89719 0.682216 8.68916L8.17655 1.2487C8.98092 0.443793 10.0525 0 11.1924 0C12.3323 0 13.4039 0.443793 14.2099 1.2503C15.0159 2.05574 15.4597 3.12735 15.4597 4.26724Z"
        fill="white"
    />
</svg>
);

export default UploadIcon;
